export default "<div class=\"<%- cssClasses %>\">\n   <%= content %>\n</div>\n";